import type { ToolbarArray } from "./types";

export const IMAGE_MAX_BYTES_BASE64 = 1048576;

export const DEFAULT_RICH_TEXT_TOOLBAR: ToolbarArray = [
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  ["bold", "italic", "underline", "strike", "blockquote"],
  [{ script: "sub" }, { script: "super" }],
  [{ list: "ordered" }, { list: "bullet" }, { indent: "-1" }, { indent: "+1" }],
  ["link", "formula", "image"],
  [{ align: "center" }, { align: "right" }],
  ["code-block"],
  ["table-better"],
  ["clean"],
];
